import { z } from "zod";
import {
  notificationTypeSchema,
  subscriptionParametersStringOrArrayRecordSchema,
  subscriptionRoleSchema,
} from "../_shared";

export const createEmailSubscriptionPayloadSchema = z.object({
  type: notificationTypeSchema,
  company: z.uuid(),
  role: subscriptionRoleSchema,
  parameters: subscriptionParametersStringOrArrayRecordSchema,
});

export type CreateEmailSubscriptionPayload = z.infer<
  typeof createEmailSubscriptionPayloadSchema
>;
